module.exports = __webpack_public_path__ + "img/UI_shouji_button_01_dae89009c.png";